import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { authGuard } from './guards/auth.guard';
import { autoAuthGuard } from './guards/auto-auth.guard';
import { firstLaunchGuard } from './guards/first-launch.guard';
import { noAuthGuard } from './guards/no-auth.guard';

const routes: Routes = [
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full',
	},
	{
		path: 'auth/callback',
		component: AuthCallbackComponent,
	},
	{
		path: 'login',
		loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
		canActivate: [noAuthGuard, firstLaunchGuard], // firstLaunchGuard redirects to /register on first launch
	},
	//tabs
	{
		path: 'app',
		loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
		canActivate: [authGuard], // Secure all child pages
	},
	{
		path: 'agb',
		loadChildren: () => import('./pages/agb/agb.module').then(m => m.AgbModule),
	},
	{
		path: 'register',
		loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule),
		canActivate: [noAuthGuard],
	},
	{
		path: 'reset-password',
		loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
	},
	{
		path: 'reset-password/:resetPasswordToken',
		loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
	},
	{
		path: 'challenge-detail/:id',
		loadChildren: () => import('./pages/challenge-detail/challenge-detail.module').then(m => m.ChallengeDetailModule),
		canActivate: [autoAuthGuard],
	},
];
@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
